import { Injectable } from '@angular/core';

// import { DocumentTemplateApiService } from '@app/shared/services/document-template-api.service';

import { CONTENT_BUILDER_STYLE } from '../constants/content-builder';
import { DocumentModel } from '../models/document.model';
import { SignatureField } from '../models/signature-field.model';

export const DYNAMICFIELD_REGEX = /{{([\w\s-_]*)}}/g;

export interface ContentBuilderVisualizeConfig {
  removeEmpty?: boolean;
}

export interface A4PrintOptions {
  margin: {
    top: string;
    bottom: string;
    left: string;
    right: string;
  };
}

@Injectable({ providedIn: 'root' })
export class ContentBuilderService {
  // private readonly cimbConfig = inject(CIMB_CONFIG);
  private startPrintWrapper = '<div class="ck ck-content ck-print redoc">';
  private startPreviewWrapper = '<div class="ck ck-content ck-preview redoc">';
  private endWrapper = '</div>';
  // private templateApiService: DocumentTemplateApiService,

  // visualize(
  //   json: FieldPayLoad,
  //   content: { html: string; css?: string[]; printOptions?: A4PrintOptions },
  //   format: 'pdf' | 'html',
  //   configs?: ContentBuilderVisualizeConfig,
  // ): Observable<any> {
  //   let dataHtml = content.html;
  //   if (dataHtml.startsWith(this.startPrintWrapper)) {
  //     dataHtml = dataHtml.slice(this.startPrintWrapper.length);
  //     dataHtml = dataHtml.slice(0, -this.endWrapper.length);
  //   }
  //   const payload = {
  //     html: this.startPreviewWrapper + dataHtml + this.endWrapper,
  //     css: content.css ? content.css : CONTENT_BUILDER_STYLE.URL.map(url => this.cimbConfig.baseUrl + url),
  //     printOptions: content.printOptions ? content.printOptions : this.getPrintOptionDefault(),
  //   };

  //   const data = this.normalizeData(json, configs);
  //   payload.html = this.normalizeHTML(payload.html, data, configs);
  //   return this.templateApiService.previewFromSampleData({
  //     format,
  //     content: payload,
  //     sampleData: data,
  //     contentType: 'jsonM',
  //   });
  // }

  countFieldByMarkupId(document: DocumentModel, markupId: string): number {
    return Object.values(document.fields.properties).filter(property => property.config?.markupId === markupId).length;
  }
  countSignatureFieldByMarkupId(document: DocumentModel, markupId: string): number {
    return Object.values(document.fields.properties).filter(
      property => property instanceof SignatureField && property.config?.markupId === markupId,
    ).length;
  }

  getPrintOptionDefault(): A4PrintOptions {
    return {
      margin: {
        top: CONTENT_BUILDER_STYLE.PRINT_OPTIONS.MARGIN.TOP + 'px',
        bottom: CONTENT_BUILDER_STYLE.PRINT_OPTIONS.MARGIN.BOTTOM + 'px',
        left: CONTENT_BUILDER_STYLE.PRINT_OPTIONS.MARGIN.LEFT + 'px',
        right: CONTENT_BUILDER_STYLE.PRINT_OPTIONS.MARGIN.RIGHT + 'px',
      },
    };
  }

  // private normalizeData(fields: FieldPayLoad, configs: ContentBuilderVisualizeConfig): object {
  //     const fieldData = {};
  //     if (!fields) {
  //         throw new Error(('fields can not empty'));
  //     }
  //     Object.keys(fields.properties).forEach(key => {
  //         if (!fields.data[key] || fields.data[key] === '') {
  //             fieldData[key] = configs?.removeEmpty ? '' : fields.properties[key].getPlaceHolder();
  //         } else {
  //             fieldData[key] = fields.data[key];
  //         }
  //     });
  //     return fieldData;
  // }

  // private normalizeHTML(html: string, data, configs?: ContentBuilderVisualizeConfig): string {
  //     if (!configs?.removeEmpty) {
  //         return html;
  //     }
  //     const domParser = new DOMParser();
  //     const doc = domParser.parseFromString(html, 'text/html');
  //     const signatureBoxNodes = doc.querySelectorAll('.redr-signature-field:not(.confirmed)');
  //     const newSignature = '<div style="' +
  //         '    width: 220px;' +
  //         '    height: 80px;' +
  //         '    border-bottom: 1px solid;' +
  //         '    margin-bottom: 2em;' +
  //         '">Signature</div>';
  //     signatureBoxNodes.forEach(signatureBoxNode => {
  //         signatureBoxNode.parentElement.innerHTML = newSignature;
  //     });
  //     const inlineFieldNodes = doc.querySelectorAll('.redr-inline-field');
  //     inlineFieldNodes.forEach(inlineField => {
  //         const labelFake = inlineField.querySelector('.label-fake-mask');
  //         if (labelFake) {
  //             const span = document.createElement('span');
  //             span.style.display = 'inline-block';
  //             span.style.borderBottom = '1px solid';
  //             span.style.width = '100px';
  //             inlineField.replaceWith(span);
  //         }
  //     });
  //     const imageFields = doc.querySelectorAll('.redr-dynamic-image');
  //     imageFields.forEach(imageWrapper => {
  //         const imgTag = imageWrapper.querySelector('img');
  //         const src = imgTag.getAttribute('src');
  //         const key = this.getKeyByRegex(src, DYNAMICFIELD_REGEX);
  //         if (!data[key]) {
  //             imageWrapper.removeChild(imgTag);
  //         }

  //     });
  //     return doc.documentElement.outerHTML;

  // }

  // private getKeyByRegex(input, regex: RegExp) {
  //     if (regex.exec(input)) {
  //         return input.replace(regex, '$1');
  //     }
  //     return input;
  // }
}
